module.exports = __webpack_public_path__ + "img/four2Red.2e399a78.png";